document.addEventListener('click', function(event) {
  const btn = event.target.closest('.quick-add-btn[data-variant-id]');
  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const variantId = btn.dataset.variantId;
  const originalLabel = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = '追加中...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent = '✓ 追加しました';

    // カートの数量を取得してバッジを更新
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) {
          // 既存のバッジを削除
          const existingBadge = cartIcon.querySelector('.cart-count-bubble');
          if (existingBadge) existingBadge.remove();

          // 新しいバッジを追加
          if (cart.item_count > 0) {
            cartIcon.insertAdjacentHTML('beforeend', `
              <div class="cart-count-bubble">
                <span aria-hidden="true">${cart.item_count}</span>
                <span class="visually-hidden">${cart.item_count} 点の商品</span>
              </div>
            `);
          }
        }
      });

    setTimeout(() => {
      btn.disabled = false;
      btn.textContent = originalLabel;
    }, 2000);
  })
  .catch(() => {
    btn.textContent = 'エラー';
    btn.disabled = false;
  });
}, true);
